export const ALLERGENS = [
  ["gluten", "Glutine", "Gluten"],
  ["crustaceans", "Crostacei", "Crustaceans"],
  ["eggs", "Uova", "Eggs"],
  ["fish", "Pesce", "Fish"],
  ["peanuts", "Arachidi", "Peanuts"],
  ["soy", "Soia", "Soy"],
  ["milk", "Latte e derivati", "Milk"],
  ["nuts", "Frutta a guscio", "Tree nuts"],
  ["celery", "Sedano", "Celery"],
  ["mustard", "Senape", "Mustard"],
  ["sesame", "Sesamo", "Sesame"],
  ["sulphites", "Anidride solforosa e solfiti", "Sulphites"],
  ["lupin", "Lupini", "Lupin"],
  ["molluscs", "Molluschi", "Molluscs"],
].map(([code, it, en], i) => ({ code, num: i + 1, it, en }));

const byCode = Object.fromEntries(ALLERGENS.map((a) => [a.code, a]));

export const allergenLabel = (code, lang = "it") => byCode[code]?.[lang] || code;
export const allergenNum = (code) => byCode[code]?.num;
